<template>
  <list
    v-show="loadingStatus === true"
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :filters="filters"
    :isAdd="false"
    :itemLink="itemLink"
    :params="params"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
    @error="loadingStatus = false"
    @succress="loadingStatus = true"
  />
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    //надо получить группу!
    this.itemLink = `business/timetables/${this.id}/lessonplans`;
    this.setLink = `business/timetables/${this.id}/lessonplans`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      filters: [
        {
          key: "author",
          title: "Автор",
          params: {
            timetable_id: this.id,
          },
        },
      ],
      loadingStatus: null,
      val: [],
      modalCreate: "client_group",
      fields: [],
      params:{type:'theme'},
      /** APIs */
      removeLink: "",
      cardLink: "item_lessonplan_list",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "title",
          title: "Автор",
          checkbox: false,
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
